import PipelineStateIcon from "~/components/shared/PipelineStateIcon";
import Icon from "~/components/shared/Icon";
import { StepProps } from "~/components/build/Header/pipeline/Step";
import { WaitJob } from "~/components/build/Show/lib/types";

export default function WaiterStep({ job, stepClassName }: StepProps<WaitJob>) {
  if (job.continueOnFailure) {
    return (
      <div
        key={job.id}
        className={`${stepClassName} dark-gray relative`}
        title="Wait for all previous steps to finish including failures"
      >
        <Icon
          icon="heroicons/20/solid/x-mark"
          className="absolute right-[3px] top-[3px] h-3 w-3 text-xs"
        />
        <PipelineStateIcon job={job} />
      </div>
    );
  }

  return (
    <div
      key={job.id}
      className={`${stepClassName} dark-gray`}
      title="Wait for all previous steps to pass"
    >
      <PipelineStateIcon job={job} />
    </div>
  );
}
